import React, { useState } from "react";
import { Form, Button, Container, Alert } from "react-bootstrap";

function ContactForm() {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    reason: "",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitted(false);
    setError("");

    try {
      const response = await fetch("https://cocmgbknd-43a11ed50cba.herokuapp.com/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await response.json();
      if (data.success) {
        setSubmitted(true);
        setFormData({ fullName: "", email: "", reason: "", message: "" });
      } else {
        setError(data.message || "Submission failed.");
      }
    } catch (err) {
      console.error(err);
      setError("An error occurred while sending the form.");
    }
  };

  return (
    <Container style={{ maxWidth: "600px", marginTop: "30px", marginBottom: "30px" }}>
      <h2 className="text-center mb-4">Get in Touch</h2>

      {submitted && <Alert variant="success">Your message was sent!</Alert>}
      {error && <Alert variant="danger">{error}</Alert>}

      <Form onSubmit={handleSubmit}>
        <Form.Group controlId="formFullName" className="mb-3">
          <Form.Label>Full Name</Form.Label>
          <Form.Control
            type="text"
            name="fullName"
            value={formData.fullName}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Form.Group controlId="formEmail" className="mb-3">
          <Form.Label>Email Address</Form.Label>
          <Form.Control
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Form.Group controlId="formSelect" className="mb-3">
          <Form.Label>Reason for Contact</Form.Label>
          <Form.Control
            as="select"
            name="reason"
            value={formData.reason}
            onChange={handleChange}
            required
          >
            <option value="" disabled>Select an option</option>
            <option>Church Happenings</option>
            <option>Join the Antique Car Show</option>
            <option>Become a Vendor</option>
            <option>Sign Up to Compete in the Highland Games</option>
          </Form.Control>
        </Form.Group>

        <Form.Group controlId="formMessage" className="mb-3">
          <Form.Label>Message</Form.Label>
          <Form.Control
            as="textarea"
            rows={5}
            name="message"
            value={formData.message}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Button variant="primary" type="submit" className="w-100">
          Submit
        </Button>
      </Form>
    </Container>
  );
}

export default ContactForm;
